import apiClient from "services/apiClient";

async function editCategory(id: any, data: any) {
  const url = `/admin/categories/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editCategory;
